import { LoanType } from '@apply/constants';

const isLoanLoc = (loanType: LoanType) => [LoanType.SubNoteConstruction, LoanType.SubNoteFixFlip].includes(loanType);

export { isLoanLoc };
